import { IContactGrouping } from 'contacts/types';
import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetManyResponse, IRequestPayload } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';
import {
  ICompanyAutocomplete,
  IFreightTerm,
  IShipmentType,
  IShippingMethod,
  IVerticalMarket,
} from 'corporate/types';

export const getVerticalMarketsAutocomplete = async (
  requestPayload: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IVerticalMarket>> => {
  const { data } = await partfinitiClient.get(
    `/corporate/market/autocomplete?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IVerticalMarket>(data.markets, data.total_count);
};

export const getShipmentTypeAutocomplete = async (
  requestPayload: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IShipmentType>> => {
  const { data } = await partfinitiClient.get(
    `/corporate/shipment-type/autocomplete?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IShipmentType>(data.shipment_types, data.total_count);
};

export const getShippingMethods = async (
  requestPayload: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IShippingMethod>> => {
  const { data } = await partfinitiClient.get(
    `/corporate_v2/shipping-method/shipping-methods?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IShippingMethod>(data.data, data.records_filtered);
};

export const getContactGroupings = async (
  requestPayload: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IContactGrouping>> => {
  const { data } = await partfinitiClient.get(
    `/corporate/contact-grouping/autocomplete?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IContactGrouping>(data.contact_groupings, data.total_count);
};

export const getCompaniesAutocomplete = async (
  requestPayload: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<ICompanyAutocomplete>> => {
  const { data } = await partfinitiClient.get(
    `/corporate/company/autocomplete?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<ICompanyAutocomplete>(data.companies, data.total_count);
};

export const getFreightTerms = async (
  requestPayload: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IFreightTerm>> => {
  const { data } = await partfinitiClient.get(
    `/corporate_v2/freight-term/freight-terms?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IFreightTerm>(data.data, data.records_filtered);
};
